import * as React from "react";
import * as ReactDOM from "react-dom";
import "./polyfill/pollyfils.js";
import '../resources/scss/main.scss';
import '../../node_modules/react-datepicker/dist/react-datepicker.css';
import "../resources/hiber/fonts/fonts.scss";
import ReduxProvider from "./navigation/ReduxProvider";

ReactDOM.render(<ReduxProvider/>, document.getElementById("root"));
